import { Stack, Typography } from "@mui/material";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useGetProductsWithMedicationsQuery } from "src/api/services/productsApi";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { usePatient } from "src/context/PatientProvider";
import { useTranslation } from "react-i18next";
import ProductCarousel from "src/shared/components/ProductCarousel";
import { useFetchCarouselProducts } from "src/hooks/useFetchCarouselProducts";
import CarouselSkeleton from "src/shared/components/CarouselSkeleton";
import ProductItems from "src/components/ProductItems";

const MembersFavorites = () => {
  const isMobile = useIsMobile();
  const gender = usePatient((p) => p.profile.gender);
  const { t } = useTranslation();
  const component = "membersFavorite";
  const { data = [], isLoading } = useGetProductsWithMedicationsQuery(
    {
      gender: gender as string,
    },
    { skip: !gender },
  );

  const { subscriptionProducts } = useFetchCarouselProducts(data);

  return isLoading ? (
    <CarouselSkeleton />
  ) : subscriptionProducts.length === 0 ? null : (
    <Stack width="100%">
      <Stack gap={0.5}>
        <Stack
          direction="row"
          justifyContent={isMobile ? "space-between" : ""}
          gap={isMobile ? 0 : 2}
        >
          <Typography variant="h5" fontWeight={600}>
            {t(`${component}.header`)}
          </Typography>
          <TrendingUpIcon fontSize="large" />
        </Stack>
        <Typography variant="h5" color="#9E9FA0" fontWeight={600}>
          {t(`${component}.subheader`, "This month")}
        </Typography>
      </Stack>
      <ProductCarousel width="100%">
        <ProductItems products={subscriptionProducts} />
      </ProductCarousel>
    </Stack>
  );
};

export default MembersFavorites;
